import { ROUTES } from "../../constants/routes.constant";

const pathWithParameter = (
  template: string,
  parameter: string,
  value: string | number,
) => `/${template.replace(`:${parameter}`, encodeURIComponent(String(value)))}`;

export const eventFormPaths = {
  admin: `/${ROUTES.EVENT_FORMS}`,
  adminDetail: (formId: string | number) =>
    pathWithParameter(ROUTES.EVENT_FORM_DETAIL, "formId", formId),
  publicForm: (publicKey: string) =>
    pathWithParameter(ROUTES.EVENT_FORM_PUBLIC, "publicKey", publicKey),
  status: (publicId: string) =>
    pathWithParameter(ROUTES.EVENT_FORM_STATUS, "publicId", publicId),
  verification: (publicId: string) =>
    pathWithParameter(ROUTES.EVENT_FORM_VERIFICATION, "publicId", publicId),
  policy: (policyKey: string) =>
    pathWithParameter(ROUTES.EVENT_FORM_POLICY, "policyKey", policyKey),
};
